import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CesCstDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCesCstDetails" */ 'modules/activityDetails/CesCstDetails/pages/CesCstDetails'
    )
)

const CesCstDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:cesId/:activityId`} component={CesCstDetails} />
      <Route exact path={`${routes.root}/:cesId`} component={CesCstDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CesCstDetailsRouting
